<div class="right" *ngIf="contact; else noContact">

  <!-- IDENTITY -->
  <div class="ident">
    <div class="av-big">{{ initials }}</div>
    <div class="nm">{{ contact.firstName }} {{ contact.lastName }}</div>
    <div class="contact">{{ contact.emailAddress }}<br>{{ contact.mobileNum }}</div>
    <div class="pills">
      <span *ngIf="contact.isVip" class="pill gold">VIP · {{ contact.vipStayCount }}{{ contact.vipStayCount === 1 ? 'st' : contact.vipStayCount === 2 ? 'nd' : contact.vipStayCount === 3 ? 'rd' : 'th' }} stay</span>
      <span *ngIf="contact.isGmpVerified" class="pill">GMP verified</span>
    </div>
  </div>

  <!-- RESERVATIONS -->
  <div class="sect">
    <h4>Reservations <span class="ct">{{ reservations.length }}</span></h4>
    <div *ngIf="reservations.length === 0" style="font-size:12px;color:var(--muted);padding:4px 0;">No reservations found.</div>
    <a *ngFor="let res of reservations" class="row" target="_blank" [routerLink]="['/reservations', res.reservationId]">
      <span class="res-tag" [ngClass]="resTagClass(res)">{{ resTagLabel(res) }}</span>
      <span class="tt">#{{ res.confirmationNumber }} · {{ res.propertyName }} <span style="color:var(--muted);font-weight:400;">↗</span></span>
      <div class="sb">
        <span class="status-dot" [ngClass]="statusDotClass(res.paymentStatus)"></span>
        {{ formatDate(res.checkInDate) }}–{{ formatDate(res.checkOutDate) }} · {{ res.guestCount }} guests · ${{ res.totalAmount | number:'1.0-0' }} · {{ res.paymentStatus }}
      </div>
    </a>
  </div>

  <!-- QUOTES -->
  <div class="sect">
    <h4>Quotes <span class="ct">{{ quotes.length }}</span></h4>
    <a *ngFor="let q of quotes" class="row" target="_blank" [routerLink]="['/quote', q.quoteId]">
      <span class="tt">{{ q.quoteNumber }} · {{ q.propertyName }} <span style="color:var(--muted);font-weight:400;">↗</span></span>
      <div class="sb">
        <span class="status-dot dot-pending"></span>
        Sent {{ q.sentDate }} · ${{ q.totalAmount | number:'1.0-0' }} · {{ q.status }}
      </div>
    </a>
  </div>

  <!-- ORDERS -->
  <div class="sect">
    <h4>Orders <span class="ct">{{ orders.length }}</span></h4>
    <a *ngFor="let o of orders" class="row" target="_blank" [routerLink]="['/order', o.orderId]">
      <span class="tt">{{ o.orderNumber }} <span style="color:var(--muted);font-weight:400;">↗</span></span>
      <div class="sb">
        <span class="status-dot" [ngClass]="statusDotClass(o.status)"></span>
        ${{ o.totalAmount | number:'1.0-0' }} · {{ o.status }} · {{ o.createDate }}
      </div>
    </a>
  </div>

  <!-- TASKS -->
  <div class="sect">
    <h4>Tasks <span class="ct">{{ tasks.length }}</span></h4>
    <div *ngIf="tasks.length === 0" style="font-size:12px;color:var(--muted);padding:4px 0;">No open tasks.</div>
    <a *ngFor="let t of tasks" class="row" target="_blank" [routerLink]="['/task-view', t.taskId]">
      <span class="tt">
        <span class="task-pri" [ngClass]="taskPriClass(t.priority)"></span>
        {{ t.title }} <span style="color:var(--muted);font-weight:400;">↗</span>
      </span>
      <div class="sb">
        {{ t.status }} · {{ t.assignedTo }}<span *ngIf="t.dueDate"> · due {{ t.dueDate }}</span>
      </div>
    </a>
  </div>

  <!-- PROFILE -->
  <div class="sect" *ngIf="contact.stayCount || contact.lifetimeValue || contact.birthday || contact.preferredIsland || contact.lastEmailDate || contact.lastSmsDate || contact.memberSince">
    <h4>Profile</h4>
    <div style="font-size:12.5px;line-height:1.65;color:var(--txt);">
      <div *ngIf="contact.stayCount || contact.lifetimeValue">🏢 {{ contact.stayCount || 0 }} previous stays · ${{ (contact.lifetimeValue || 0) | number:'1.0-0' }} lifetime</div>
      <div *ngIf="contact.birthday">🎂 Birthday: {{ contact.birthday }}</div>
      <div *ngIf="contact.preferredIsland">🌺 Preferred island: {{ contact.preferredIsland }}</div>
      <div *ngIf="contact.lastEmailDate">✉️ Last email: {{ contact.lastEmailDate }}</div>
      <div *ngIf="contact.lastSmsDate">💬 Last SMS: {{ contact.lastSmsDate }}</div>
      <div *ngIf="contact.memberSince">🗓 Member since: {{ formatDate(contact.memberSince) }}</div>
    </div>
  </div>

  <!-- OPEN FULL GMP -->
  <a class="open-full" *ngIf="contact.gmpId" target="_blank" [routerLink]="['/guest-master-profile', contact.gmpId]">
    Open full Guest Master Profile →
  </a>

</div>
<ng-template #noContact>
  <!-- Fix 1: When a conversation is selected but no guest has been identified yet (e.g. the
       thread component hasn't emitted guestIdentified, or it's a system-only conversation),
       show a neutral loading/no-contact state rather than "Select a conversation". The parent
       component already gates the right rail on activeConversationId, so this template only
       renders when a conversation is open but the guest identity is unavailable. -->
  <div class="right" style="display:flex;align-items:center;justify-content:center;color:var(--muted);font-size:13px;text-align:center;padding:24px 16px;">
    No guest profile available for this conversation.
  </div>
</ng-template>
